import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getCalendarFeed,
  rotateCalendarFeed,
  createCalendarFeed,
} from "../api/calendarFeedApi";

export const useCalendarFeed = () => {
  return useQuery({
    queryKey: ["calendarFeed"],
    queryFn: getCalendarFeed,
  });
};

export const useRotateCalendarFeed = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rotateCalendarFeed,
    onSuccess: (data) => {
      // Seed the rotate response (the ONLY place the raw feed URL exists) into
      // the cache directly. Do NOT invalidate/refetch: GET /settings/calendar-feed
      // returns feedUrl:null after the first fetch (create-once + rotate-to-reveal),
      // so a refetch would immediately overwrite the fresh URL with null and snap
      // the UI back to the hidden state.
      queryClient.setQueryData(["calendarFeed"], data);
    },
  });
};

export const useCreateCalendarFeed = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCalendarFeed,
    onSuccess: (data) => {
      // Same trap as rotate: seed the create response (the ONLY place the raw
      // feed URL exists on first creation) directly into the cache. Do NOT
      // invalidate/refetch: GET /settings/calendar-feed always returns
      // feedUrl:null (create-once + rotate-to-reveal), so a refetch would
      // immediately overwrite the fresh URL with null and snap the UI back
      // to the hidden/not-generated state.
      queryClient.setQueryData(["calendarFeed"], data);
    },
  });
};
